module.exports = __webpack_public_path__ + "img/CM-JRF-25-GMC-Established.ead7743d.jpg";